import {
  ExtendedFieldMappingEditorValue,
  transformSimpleValueInput,
} from '@components/text-editors/addons/field-mapping';
import { createPlaceholderHtml, createPlaceholderNode } from '@components/text-editors/helpers';
import { abbreviateDate } from '@utils/date';

export const tag = 'date-placeholder';

const attributes = ['value', 'label'];

export const getPlaceholderHtml = createPlaceholderHtml({ tag, attributes });

export const DatePlaceholder = createPlaceholderNode({
  attributes,
  renderText: getPlaceholderHtml,
  tag,
});

export const transformInput = (input: ExtendedFieldMappingEditorValue[]) =>
  transformSimpleValueInput(input, (value) =>
    getPlaceholderHtml({
      value,
      label: abbreviateDate(value, 'en'),
    })
  );
